export const BACKUP_CODES_TITLE_ID = 'backup-codes-title';
export const BACKUP_CODES_DESCRIPTION_ID = 'backup-codes-description';

// Downloaded PDF layout. The document is drawn with jsPDF rather than snapshotting
// the printable DOM: a DOM snapshot renders responsive CSS inside a fixed-width
// container, which shattered every code across several lines and made the text
// layer unusable for copy/paste.
export const PDF_PAGE_FORMAT = 'a4';
export const PDF_PAGE_ORIENTATION = 'portrait';
export const PDF_UNIT = 'mm';

export const PDF_PAGE_MARGIN_MM = 15;
export const PDF_CONTENT_WIDTH_MM = 180;

export const PDF_LOGO_URL = '/images/logos/scalar-logo.jpg';
export const PDF_LOGO_FORMAT = 'JPEG';
export const PDF_LOGO_NATURAL_WIDTH_PX = 559;
export const PDF_LOGO_NATURAL_HEIGHT_PX = 144;
export const PDF_LOGO_WIDTH_MM = 40;

// Vertical gap left below each block before the next one starts.
export const PDF_LOGO_SPACING_MM = 12;
export const PDF_TITLE_SPACING_MM = 6;
export const PDF_SUBTITLE_SPACING_MM = 4;
export const PDF_SUPPORTING_TEXT_SPACING_MM = 10;

export const PDF_CODES_BOX_PADDING_MM = 8;
export const PDF_CODES_BOX_CORNER_RADIUS_MM = 2;
export const PDF_CODE_LINE_HEIGHT_MM = 9;
// Horizontal offset of a code from its "1." index, which is drawn in a left gutter.
export const PDF_CODE_GUTTER_MM = 13;

export const PDF_TITLE_FONT_SIZE_PT = 16;
export const PDF_SUBTITLE_FONT_SIZE_PT = 11;
export const PDF_SUPPORTING_TEXT_FONT_SIZE_PT = 10;
export const PDF_CODE_FONT_SIZE_PT = 14;
export const PDF_CODE_INDEX_FONT_SIZE_PT = 9;

export const PDF_TEXT_FONT_FAMILY = 'helvetica';
// Fixed-pitch so codes stay readable and never look like neighbouring glyphs.
export const PDF_CODE_FONT_FAMILY = 'courier';
export const PDF_FONT_STYLE_BOLD = 'bold';
export const PDF_FONT_STYLE_NORMAL = 'normal';

export const MM_PER_POINT = 0.3528;
export const PDF_LINE_HEIGHT_RATIO = 1.25;
